export const experienceItems = [
  {
    name: {
      en: "NAVI",
      zh: "NAVI",
      ja: "NAVI",
    },
    href: "https://app.naviprotocol.io/",
    linkLabel: "app.naviprotocol.io",
    logo: "/assets/experience/navi-logo.png",
    brief: {
      en: "This set of work sits under the NAVI ecosystem: product implementation, backend and contract delivery, and protocol data handling shipped into live user-facing surfaces.",
      zh: "这组工作都在 NAVI 生态下面，涵盖产品实现、后端与合约交付，以及面向真实用户场景的协议数据处理。",
      ja: "この一連の仕事は NAVI エコシステムの中で行ったもので、プロダクト実装、バックエンドとコントラクトの開発、そして公開向けプロトコルデータ処理までを含む。",
    },
    projects: [
      {
        name: {
          en: "Volo",
          zh: "Volo",
          ja: "Volo",
        },
        href: "https://www.volosui.com/",
        linkLabel: "volosui.com",
        logo: "/assets/experience/volo-icon.png",
        brief: {
          en: "Contributed to the product development of Volo on Sui, focusing on the protocol-facing implementation that made staking and vault flows work cleanly in production.",
          zh: "参与 Volo 在 Sui 上的产品开发，主要做协议能力到真实 staking 与 vault 产品体验之间的实现落地。",
          ja: "Sui 上の Volo のプロダクト開発に参加し、ステーキングとボールト体験を本番で機能させるための実装を担当した。",
        },
      },
      {
        name: {
          en: "Astros DCA",
          zh: "Astros DCA",
          ja: "Astros DCA",
        },
        href: "https://astros.ag/dca",
        linkLabel: "astros.ag/dca",
        logo: "/assets/experience/astros-icon.png",
        brief: {
          en: "Worked on the DCA product surface on Astros, owning the backend and contract-facing implementation needed to make recurring execution behave reliably in production.",
          zh: "参与 Astros 的 DCA 产品实现，后端与合约侧链路都由我负责，重点保证定投执行在生产环境中的稳定性与一致性。",
          ja: "Astros の DCA プロダクト実装に関わり、定期実行が本番環境で安定して動くためのバックエンドおよびコントラクト側の実装を担当した。",
        },
      },
      {
        name: {
          en: "NAVI Parameter Optimization",
          zh: "NAVI 参数优化功能",
          ja: "NAVI パラメータ最適化機能",
        },
        href: "https://app.naviprotocol.io/",
        linkLabel: "app.naviprotocol.io",
        logo: "/assets/experience/navi-logo.png",
        brief: {
          en: "Shipped the parameter-optimization feature used inside NAVI, turning design and tuning logic into a production-facing workflow instead of leaving it as offline analysis.",
          zh: "实现了 NAVI 里实际使用的参数优化功能，把原本偏设计和分析侧的逻辑做成了可上线、可使用的产品流程。",
          ja: "NAVI 内で使われるパラメータ最適化機能を実装し、設計とチューニングのロジックをオフライン分析ではなく実運用フローに変えた。",
        },
      },
      {
        name: {
          en: "Volo Vault on DeFiLlama",
          zh: "DeFiLlama 上的 Volo Vault",
          ja: "DeFiLlama 上の Volo Vault",
        },
        href: "https://defillama.com/protocol/volo-vault",
        linkLabel: "defillama.com/protocol/volo-vault",
        logo: "/assets/experience/defillama-logo.png",
        brief: {
          en: "Handled the data processing and analysis behind the Volo Vault analytics surface on DeFiLlama, shaping protocol data into external metrics that were clean enough for public consumption.",
          zh: "负责 Volo Vault 在 DeFiLlama 上展示所需的数据处理与分析工作，把协议数据整理成适合公开展示和比较的指标。",
          ja: "DeFiLlama 上の Volo Vault 向けに、公開表示に耐える形へプロトコルデータを整える処理と分析を担当した。",
        },
      },
    ],
  },
  {
    name: {
      en: "HBIS / Hesteel",
      zh: "河钢集团",
      ja: "HBIS / 河鋼",
    },
    href: "http://www.hbisdt.com/",
    linkLabel: "hbisdt.com",
    logo: "/assets/experience/hbis-logo.png",
    brief: {
      en: "My work at HBIS sat on the industrial AI side, applying vision models and LLM-based tooling to production data, defect analysis, and factory-facing workflows.",
      zh: "我在 HBIS 的工作更偏工业 AI，一边做缺陷检测相关的视觉模型，一边把大语言模型能力接进生产数据分析和工厂实际流程里。",
      ja: "HBIS では産業 AI 側の仕事を担当し、欠陥検出向けの視覚モデルと、工場向けワークフローに接続する LLM ツールの両方に取り組んだ。",
    },
  },
];
